// extracted by mini-css-extract-plugin
export default {"tooltip":"Xn-z","sharingV2":"Yn-z","sharingIconsV2":"Zn-z","links":"_n-z","link":"ao-z","facebookV2":"bo-z","twitterV2":"co-z","pinterestV2":"do-z"};